import {
  MateSpriteAction,
  MateSpriteDirection,
  ScriptGameRoomMode,
  ScriptGameRoomPaymentMode,
  ScriptGameRoomStartMode,
  ScriptGameRoomStatus,
} from "@/enums/game";
import { ChatScene } from "./chat";
import { Mate, Media } from "./entity";

export interface ScriptGameRoom extends Entity {
  uuid: string;
  mateId: number;
  chatSceneId: number;
  name: string;
  shortDefinition: string;
  maxPlayers: number;
  duration: number;
  dtStart: string;
  startMode: ScriptGameRoomStartMode;
  mode: ScriptGameRoomMode;
  status: ScriptGameRoomStatus;
  paymentMode: ScriptGameRoomPaymentMode;
  mateSessionId: number;
  serverRoomId: string;
  viewerCount: number;

  chatScene?: ChatScene;
  mate?: Mate;
  mateSession?: MateSession;
  playerzz: ScriptGameRoomPlayer[];
}

/**
 * @type prompt {
 *   sex: Sex;
 *   items: SelectedItems;
 * }
 */
export interface MateSprite extends Entity {
  name?: string;
  prompt?: string; // json string, specific format see above
  mode?: MateSpriteMode;
  mateTraitId?: number;
  imageMediaId?: number;
  imageMedia?: Media;
  referenceMediaId?: number;
  referenceMedia?: Media;
  uuid?: string;

  taskId?: string;
  mateId: number;
  mate: Mate;
  frameMediaId?: number;
  frameMedia?: Media;
  animationzz?: MateSpriteAnimation[];
  isDefault?: boolean;
  isOnScreen?: boolean;
  status?: MateSpriteStatus;
  portraitMediaId?: number;
  portraitMedia?: Media;
  avatarMediaId?: number;
  avatarMedia?: Media;
  promptDescription?: string;
}

export interface MateSpriteAnimation extends Entity {
  action: MateSpriteAction;
  direction: MateSpriteDirection;
  mediaId: number;
  spriteId: number;
  media?: Media;
}

export enum MateSpriteTaskStatus {
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export enum MateSpriteMode {
  Prompt = 1,
  Image = 2,
  MateTrait = 3,
  Compose = 4,
}

export enum MateSpriteStatus {
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export enum N8nTaskStatus {
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export interface ScriptGameRoomPlayer extends Entity {
  roomId: number;
  mateId: number;
  mateSpriteId: number;
  mate?: Mate;
  mateSprite?: MateSprite;
}
